import { render } from "./AppFileUpload.vue?vue&type=template&id=ddf20848&scoped=true"
import script from "./AppFileUpload.vue?vue&type=script&lang=js"
export * from "./AppFileUpload.vue?vue&type=script&lang=js"

import "./AppFileUpload.vue?vue&type=style&index=0&id=ddf20848&lang=scss&scoped=true"

import exportComponent from "/Users/edsonfer/Documents/dev-projects/node-projects/portal-gignet-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddf20848"]])

export default __exports__